import { render } from "./videoInfo.vue?vue&type=template&id=4a82f486&scoped=true"
import script from "./videoInfo.vue?vue&type=script&lang=js"
export * from "./videoInfo.vue?vue&type=script&lang=js"

import "./videoInfo.vue?vue&type=style&index=0&id=4a82f486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a82f486"]])

export default __exports__